<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible">        
        <div class="friend-modal u-window">           
            <div class="dialog-content">              
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-friend"></div>
                    <div class="friend-view">
                        <div class="list-swiper">
                            <ul>
                                <li v-for="(item,index) in list" :key="index" :class=" !item.isLoginGame? 'wait' : ''">
                                    <div class="avatar"><img v-bind:src="'https://web-resource.17m3.com/m3guo/202111/a20211124back/images/a/' + item.headImg +'.png'"></div>
                                    <p class="player-name">{{ item.nickName }}</p>
                                    <div class="status" :class="item.isLoginGame ? 'act' : ''"></div>
                                </li>                 
                            </ul>  
                        </div>             
                    </div>

                    <div class="u-pager" v-if="allpages > 1">
                        <span v-for="n in allpages" :key="n" :class="n==now ? 'act': ''" @click="setpage(n)">{{ n }}</span>
                    </div>    

                    <div class="u-btn invite" @click="call_share"></div>
                </div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    data : function () {
        return {
            visible : false,
            list : [],
            allpages : 0,
            now : 1,
            perpage : 10, 
            code : '',         
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        setpage(n){
            var _this = this;
            this.$axios.get(_this.$global.ajax_url_map.friend_list,{
                params : {
                    pageindex : n,
                    pagesize: _this.perpage,
                }
            })
            .then(res => {
                if(res.data.code == 0){
                    //success
                    _this.list = res.data.data.list;
                    _this.allpages = Math.min(res.data.data.allPages,10);
                    _this.now = n;
                }
                else{
                    _this.$toast(res.data.message);
                }
            });            
        },
        call_share (){
            this.$share_modal({
                code : this.code,
            })

            this.destroyElement();
        },               
    }    
}
</script>

<style scoped>

@media screen and (min-device-width: 1025px){
    .friend-modal{
        width: 880px;
        padding-top: 25px;
        padding-bottom: 40px;
        background-color: #ded4be;
    }

    .t-friend{
        width: 175px;
        height: 37px;
        margin: 0 auto 20px;
        background-image: url(../../images/title-friend.png);
    }

    .friend-modal .u-btn.close{
        top: 0;
    }

    .list-swiper{
        display: flex;
        align-items: center;
    }

    .friend-view .list-swiper ul{
        display: flex;
        flex-wrap: wrap;
        padding : 0 45px;
        justify-content: space-between;
    }

    .friend-view .list-swiper li{
        position: relative;
        margin-right: 25px;
        margin-bottom: 15px;
    }

    .friend-view .list-swiper .avatar{
        width: 133px;
        height: 137px;
        background-image: url(../../images/bg-avatar.png);
    }

    .friend-view .list-swiper .add .avatar{
        background-image: url(../../images/bg-add.png);
    }

    .friend-view .list-swiper .status{
        width: 74px;
        height: 25px;
        margin: 5px auto 0;
        background-image: url(../../images/status-wait.png);
    }

    .friend-view .list-swiper .status.act{
        background-image: url(../../images/status-done.png);
    }    

    .friend-view .list-swiper li.wait::after{
        display: block;
        content: '';
        position: absolute;
        top: -10px;
        right: -10px;
        width: 33px;
        height: 96px;
        background-image: url(../../images/label-wait.png);
    }

    .friend-view .player-name{
        width: 133px;
        height: 24px;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;        
        color: #a79079;
        text-align: center;
    }    

    .u-pager{
        width: 100%;
        font-size: 18px;
        margin-top: 10px;
        color: #63544b;
        text-align: center;
    }

    .u-pager span{
        padding: 0 10px;
        cursor: pointer;
    }

    .u-pager span.act{
        color: #b18b27;
    }    

    .u-btn.invite{
        width: 166px;
        height: 49px;
        margin: 15px auto 0;
        background-image: url(../../images/btn-invite.png);    
    }
    
    .u-btn.ok:hover{
        background-image: url(../../images/btn-invite_hover.png);   
    }  
}
    
@media screen and (max-device-width: 1024px){
    .friend-modal{
        width: 670px;
        padding-top: 25px;
        padding-bottom: 40px;
        background-color: #ded4be;
    }

    .t-friend{
        width: 210px;
        height: 44px;
        margin: 0 auto 20px;
        background-image: url(../../images/m/title-friend.png);
    }

    .list-swiper{
        display: flex;
        align-items: center;
    }

    .friend-view .list-swiper ul{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0 30px;
    }

    .friend-view .list-swiper li{
        position: relative;
        margin-right: 20px;
        margin-bottom: 15px;
    }

    .friend-view .list-swiper .avatar{
        width: 102px;
        height: 105px;
        background-image: url(../../images/m/bg-avatar.png);
    }

    .friend-view .player-name{
        width: 102px;
        height: 30px;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;        
        color: #a79079;
        text-align: center;
    }    

    .list-swiper .avatar img{
        width: 100%;
        height: 100%;
    }

    .friend-view .list-swiper .add .avatar{
        background-image: url(../../images/m/bg-add.png);
    }

    .friend-view .list-swiper .status{
        width: 90px;
        height: 32px;
        margin: 14px auto 0;
        background-image: url(../../images/m/status-now.png);
    }

    .friend-view .list-swiper .status.act{
        background-image: url(../../images/m/status-done.png);
    }

    .friend-view .list-swiper li.wait::after{
        display: block;
        content: '';
        position: absolute;
        top: -10px;
        right: -10px;
        width: 41px;
        height: 122px;
        background-image: url(../../images/m/label-wait.png);
    }

    .u-pager{
        width: 100%;
        font-size: 24px;
        margin-top: 10px;
        color: #63544b;
        text-align: center;
    }

    .u-pager span{
        padding: 0 10px;
        cursor: pointer;
    }

    .u-pager span.act{
        color: #b18b27;
    }    

    .u-btn.invite{
        width: 218px;
        height: 65px;
        margin: 15px auto 0;
        background-image: url(../../images/m/btn-invite.png);    
    } 
}     


      
</style>


// WEBPACK FOOTER //
// src/components/FriendModal/friendModal.vue